import { render, staticRenderFns } from "./compr.vue?vue&type=template&id=7c2e53d4&"
import script from "./compr.vue?vue&type=script&lang=js&"
export * from "./compr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports